import { ListRootFiCompaniesResponseV4 } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import type { UseRootFiIntegrationsResult } from './types';

/**
 * RootFi integrations across every corporation of a company
 * (`GET rootfi/company?scope=company&companyId=`).
 */
export function useCompanyRootFiIntegrations(
  companyId: number | null | undefined
): UseRootFiIntegrationsResult {
  const { data, error, mutate, isLoading } =
    useSWR<ListRootFiCompaniesResponseV4>(
      companyId
        ? `rootfi/company?scope=company&companyId=${companyId}&include=corporation`
        : null,
      async (url: string) =>
        SWRFetcher({ method: 'GET' })(
          url
        ) as Promise<ListRootFiCompaniesResponseV4>
    );

  return {
    data: data?.companies.filter((row) => row.integration != null) ?? [],
    error,
    mutate,
    isLoading,
  };
}
